if (!customElements.get('product-details-tabs')) {
  customElements.define('product-details-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.panels = this.tabs.map(tab => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
      this.tablist = this.querySelector('[role="tablist"]');
      this.viewport = this.querySelector('.product-tabs__viewport');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs.forEach((tab, index) => {
        if (tab.tagName === 'A') tab.removeAttribute('href');
        tab.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const x = window.scrollX;
          const y = window.scrollY;
          this.select(index);
          window.scrollTo(x, y);
        }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab === event.target || tab.contains(event.target));
        if (index >= 0) this.select(index);
      }, options);
      this.observer = new ResizeObserver(() => this.positionIndicator());
      this.observer.observe(this.tablist);
      this.tabs.forEach(tab => this.observer.observe(tab));
      const selected = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      this.select(Math.max(0, selected), false);
    }

    select(index, animate = true) {
      if (this.active === index || !this.panels[index]) return;
      this.animation?.cancel();
      this.active = index;
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('first', selected);
        const panel = this.panels[i];
        if (!panel) return;
        panel.hidden = !selected;
        panel.classList.toggle('hide', !selected);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = selected ? 0 : -1;
      });
      this.positionIndicator();
      if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation = this.panels[index].animate([
          { opacity: 0, transform: 'translateY(6px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 260, easing: 'ease-out' });
      }
      if (animate) {
        const tab = this.tabs[index];
        const left = tab.offsetLeft;
        const right = left + tab.offsetWidth;
        if (left < this.viewport.scrollLeft) this.viewport.scrollLeft = left;
        else if (right > this.viewport.scrollLeft + this.viewport.clientWidth) {
          this.viewport.scrollLeft = right - this.viewport.clientWidth;
        }
      }
    }

    positionIndicator() {
      const tab = this.tabs[this.active];
      if (!tab) return;
      this.tablist.style.setProperty('--tab-left', `${tab.offsetLeft}px`);
      this.tablist.style.setProperty('--tab-width', `${tab.offsetWidth}px`);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.animation?.cancel();
      this.active = undefined;
    }
  });
}
